module.exports = __webpack_public_path__ + "static/media/logo.813f5b82.svg";